export function splitReferentialGrid(gridData: string[][]): {
  headers: string[]
  rows: string[][]
} {
  if (!gridData?.length) {
    return { headers: [], rows: [] }
  }

  const headers = gridData[0] ?? []

  if (gridData.length <= 1) {
    return { headers, rows: [] }
  }

  return { headers, rows: gridData.slice(1) }
}

export function getColumnCount(headers: string[], rows: string[][]): number {
  const fromHeaders = headers.length
  const fromRows = rows.reduce((max, row) => Math.max(max, row.length), 0)
  return Math.max(fromHeaders, fromRows, 1)
}

export function padRow(row: string[], columnCount: number): string[] {
  return Array.from({ length: columnCount }, (_, index) => row[index] ?? '')
}

export function countFilledCells(rows: string[][]): {
  filled: number
  total: number
  percent: number
} {
  let filled = 0
  let total = 0

  for (const row of rows) {
    for (const cell of row) {
      total += 1
      if (String(cell ?? '').trim() !== '') {
        filled += 1
      }
    }
  }

  const percent = total === 0 ? 0 : Math.round((filled / total) * 100)

  return { filled, total, percent }
}

export function filterGridRows(
  rows: string[][],
  search: string,
  columnCount: number
): string[][] {
  return filterGridRowsWithIndices(rows, search, columnCount).map(
    ({ row }) => row
  )
}

export function filterGridRowsWithIndices(
  rows: string[][],
  search: string,
  columnCount: number
): { row: string[]; sourceIndex: number }[] {
  const indexedRows = rows.map((row, sourceIndex) => ({ row, sourceIndex }))
  const normalizedSearch = search.trim().toLowerCase()

  if (!normalizedSearch) {
    return indexedRows
  }

  return indexedRows.filter(({ row }) =>
    padRow(row, columnCount).some((cell) =>
      cell.toLowerCase().includes(normalizedSearch)
    )
  )
}
